import React, { ReactNode } from 'react';

import Column from '../../../Grid/Column/Column';
import DesktopMultiActions from './DesktopMultiActions/DesktopMultiActions';
import MobileMultiActions from './MobileMultiActions/MobileMultiActions';
import Row from '../../../Grid/Row/Row';
import { PrimaryActionType, SecondaryActionType, TertiaryActionType } from '../../Block';

export interface MultiActionsProps {
  actionSize?: 'wide' | 'full';
  actionIsLoading?: boolean;
  primaryAction?: PrimaryActionType;
  secondaryAction?: SecondaryActionType;
  tertiaryAction?: TertiaryActionType;
  children?: ReactNode;
  formId?: string | undefined;
}

function MultiActions({
  actionSize,
  actionIsLoading,
  secondaryAction,
  tertiaryAction,
  primaryAction,
  formId,
}: MultiActionsProps) {
  return (
    <Row>
      <Column mobile="hidden" tabletPortrait="12-of-12">
        <DesktopMultiActions
          actionSize={actionSize}
          actionIsLoading={actionIsLoading}
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
          tertiaryAction={tertiaryAction}
          formId={formId}
        />
      </Column>
      <Column mobile="12-of-12" tabletPortrait="hidden">
        <MobileMultiActions
          actionIsLoading={actionIsLoading}
          primaryAction={primaryAction}
          secondaryAction={secondaryAction}
          tertiaryAction={tertiaryAction}
          formId={formId}
        />
      </Column>
    </Row>
  );
}

export default MultiActions;
